import type { InventoryItem } from '../../types/inventory'

import { getOfflineDb } from '../dbFactory'

export type InventoryItemListParams = {
  farmId?: string
}

export class DexieInventoryItemRepo {
  async list(params: InventoryItemListParams = {}): Promise<InventoryItem[]> {
    const farmId = params.farmId?.trim() || undefined
    const table = getOfflineDb().inventoryItems

    const rows = farmId
      ? await table.where('farmId').equals(farmId).toArray()
      : await table.toArray()

    return rows.slice().sort((a, b) => a.name.localeCompare(b.name))
  }

  async getById(id: string): Promise<InventoryItem | undefined> {
    return getOfflineDb().inventoryItems.get(id)
  }

  async upsert(item: InventoryItem): Promise<void> {
    await getOfflineDb().inventoryItems.put(item)
  }

  async upsertMany(items: InventoryItem[]): Promise<void> {
    if (items.length === 0) return
    await getOfflineDb().inventoryItems.bulkPut(items)
  }

  async replaceAll(items: InventoryItem[]): Promise<void> {
    const db = getOfflineDb()
    await db.transaction('rw', db.inventoryItems, async () => {
      await db.inventoryItems.clear()
      if (items.length > 0) {
        await db.inventoryItems.bulkPut(items)
      }
    })
  }

  async delete(id: string): Promise<void> {
    await getOfflineDb().inventoryItems.delete(id)
  }

  async clear(): Promise<void> {
    await getOfflineDb().inventoryItems.clear()
  }
}

export const dexieInventoryItemRepo = new DexieInventoryItemRepo()
